const onDownloadProgress = (progressEvent, setProgress, filename, contentLength) => {
  const progress = Math.floor(progressEvent.loaded / contentLength * 100);
  setProgress(progress, filename);
}

export default onDownloadProgress;
